<template>
	<v-container fluid class="pt-0">
		<v-row>
			<v-col cols="12" xl="12" lg="12" md="12">
				<v-card flat outlined>
					<v-card-text>
						<v-row>
							<v-col>
								<v-card-title class="pa-2">{{ $t('titles.userAccountInformations') }}</v-card-title>
							</v-col>
							<v-col class="d-flex justify-end">
								<v-btn
									v-if="inEditMode && user.id != 0"
									class="mr-2"
									color="primary"
									@click="newPasswordClick"
								>
									<v-icon small>fa-lock</v-icon>&nbsp;{{ $t('buttons.generateNewPassword') }}
								</v-btn>
								<v-btn v-if="inEditMode" class="ml-2 mr-2" color="primary" @click="saveClick(null)">
									<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
								</v-btn>
								<v-btn v-if="!inEditMode" class="ml-2 mr-2" color="primary" @click="editClick()">
									<v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
								</v-btn>
								<v-btn class="mr-2" color="basicButton" @click="backClick">
									<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
								</v-btn>
							</v-col>
						</v-row>
						<v-row wrap>
							<v-col cols="12" v-if="inEditMode && this.$route.params.id != 0">
								<InputField
									:readonly="true"
									v-model="user.id"
									:label="'* ' + $t('fields.id')"
								></InputField>
							</v-col>
							<v-col cols="12">
								<InputField
									:readonly="!inEditMode"
									v-model="user.first_name"
									:errorBorder="!userValidation.first_name"
									:label="'* ' + $t('fields.firstName')"
								></InputField>
							</v-col>
							<v-col cols="12">
								<InputField
									:readonly="!inEditMode"
									v-model="user.last_name"
									:errorBorder="!userValidation.last_name"
									:label="'* ' + $t('fields.lastName')"
								></InputField>
							</v-col>
							<v-col cols="12">
								<InputField
									:readonly="!inEditMode"
									v-model="user.email"
									:errorBorder="!userValidation.email"
									:label="'* ' + $t('fields.email')"
								></InputField>
							</v-col>
							<v-col cols="12">
								<InputField
									:readonly="!inEditMode"
									v-model="user.phone"
									:errorBorder="!userValidation.phone"
									:label="$t('fields.phone')"
								></InputField>
							</v-col>
							<v-col cols="12">
								<Dropdown
									:readonly="!inEditMode"
									v-model="user.user_role_id"
									:ajax="true"
									:data="'user-roles'"
									:errorBorder="!userValidation.user_role_id"
									:label="'* ' + $t('fields.role')"
								></Dropdown>
							</v-col>
							<v-col cols="12" v-if="user.user_role_id == 2">
								<DropdownMultipleWithSelectAll
									:readonly="!inEditMode"
									v-model="user.offices"
									:ajax="true"
									:data="'offices'"
									:errorBorder="!userValidation.offices"
									:label="'* ' + $t('fields.office')"
								></DropdownMultipleWithSelectAll>
							</v-col>
							<v-col v-if="user.id == 0" cols="12">
								<InputField
									:readonly="!inEditMode"
									v-model="user.password"
									:errorBorder="!userValidation.password"
									:label="'* ' + $t('fields.password')"
								></InputField>
							</v-col>
							<v-col v-if="user.id == 0" cols="12">
								<InputField
									:readonly="!inEditMode"
									v-model="user.confirmPassword"
									:errorBorder="!userValidation.confirmPassword"
									:label="'* ' + $t('fields.confirmPassword')"
								></InputField>
							</v-col>
							<v-col cols="12">
								<CheckBox
									:readonly="!inEditMode"
									v-model="user.active"
									:label="$t('fields.active')"
								></CheckBox>
							</v-col>
							<v-col cols="12">
								<CheckBox
									:readonly="!inEditMode"
									v-model="user.locked"
									:label="$t('fields.locked')"
								></CheckBox>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import InputField from '../../trinkets/InputField';
import CheckBox from '../../trinkets/CheckBox';
import Dropdown from '../../trinkets/Dropdown';
import DropdownMultiple from '../../trinkets/DropdownMultiple';
import DropdownMultipleWithSelectAll from '../../trinkets/DropdownMultipleWithSelectAll';
import User from '../../../models/User';

export default {
	name: 'UserAccount',
	components: { CheckBox, InputField, Dropdown, DropdownMultiple, DropdownMultipleWithSelectAll },
	data: function () {
		return {
			user: new User({ id: this.$route.params.id }),
			userValidation: new User({}, true),
			initialLoad: false,
			inEditMode: false,
			lockKey: 'user-account',
			lockTimer: null,
		};
	},
	methods: {
		editClick() {
			let vm = this;
			this.$setLock(this, this.lockKey + '|' + this.user.id, (data) => {
				if (data.success) {
					vm.inEditMode = true;
					vm.lockTimer = setInterval(() => {
						vm.$setLock(vm, vm.lockKey + '|' + vm.user.id);
					}, 10000);
				} else {
					vm.$alert(
						vm
							.$t('alerts.recordLocked')
							.split('%name%')
							.join(data.locked_by.first_name + ' ' + data.locked_by.last_name)
					);
				}
			});
		},
		newPasswordClick() {
			let vm = this;
			this.$verify(this.$t('alerts.generatePasswordQuestion'), (result) => {
				if (result) {
					vm.saveClick(() => {
						vm.$APICall('post', 'password-recovery', { email: vm.user.email }, (data, success) => {
							if (success) {
								vm.$alert(vm.$t('alerts.passwordResetSuccess'));
							} else {
								vm.$alert(vm.$t('alerts.passwordResetFail'));
							}
							vm.$removeLock(vm, vm.lockKey + '|' + vm.user.id);
							clearInterval(vm.lockTimer);
						});
					});
				}
			});
		},
		backClick() {
			this.$router.go(-1);
		},
		saveClick(after = null) {
			let success = true;
			let errorMessages = '';

			if (this.user.first_name == '') {
				success = false;
				this.userValidation.first_name = false;
			} else {
				if (this.user.first_name.length > 50) {
					this.userValidation.first_name = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.firstName'))
							.replace('%length%', '50') + '<br />';
				} else {
					this.userValidation.first_name = true;
				}
			}

			if (this.user.last_name == '') {
				success = false;
				this.userValidation.last_name = false;
			} else {
				if (this.user.last_name.length > 50) {
					this.userValidation.last_name = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.lastName'))
							.replace('%length%', '50') + '<br />';
				} else {
					this.userValidation.last_name = true;
				}
			}

			if (this.user.phone != '' && this.user.phone != null && this.user.phone.length > 20) {
				this.userValidation.phone = false;
				errorMessages +=
					this.$t('alerts.lengthError')
						.replace('%field%', this.$t('fields.phone'))
						.replace('%length%', '20') + '<br />';
			} else {
				this.userValidation.phone = true;
			}

			if (this.user.email == '') {
				success = false;
				this.userValidation.email = false;
			} else {
				if (!this.$checkEmail(this.user.email)) {
					this.userValidation.email = false;
					errorMessages += this.$t('alerts.formatError').split('%value%').join('E-mail') + '<br />';
				} else {
					this.userValidation.email = true;
				}
			}

			if (!this.user.offices.length && this.user.user_role_id == 2) {
				success = false;
				this.userValidation.offices = false;
			} else {
				if (this.user.user_role_id == 1) this.user.offices = [];
				this.userValidation.offices = true;
			}

			if (this.user.id == 0) {
				if (this.user.password.trim() == '') {
					success = false;
					this.userValidation.password = false;
				} else {
					let passwordValidation = '';

					if (this.user.password.length < 8) {
						success = false;
						this.userValidation.password = false;
						passwordValidation += this.$t('alerts.passwordLength') + '<br />';
					}

					let letters = 0;
					let digits = 0;
					let others = 0;
					for (let i = 0; i < this.user.password.length; i++) {
						let character = this.user.password[i];
						let letter = character.toLowerCase() !== character.toUpperCase();
						let digit = character >= '0' && character <= 9;
						if (letter) letters++;
						if (digit) digits++;
						if (!letter && !digit) others++;
					}
					if (letters === 0) passwordValidation += this.$t('alerts.passwordLetters') + '<br />';
					if (digits === 0) passwordValidation += this.$t('alerts.passwordDigits') + '<br />';
					if (others === 0) passwordValidation += this.$t('alerts.passwordOthers') + '<br />';

					if (passwordValidation !== '') {
						errorMessages += passwordValidation;
						this.userValidation.password = false;
					} else {
						this.userValidation.password = true;
					}

					if (this.user.password !== this.user.confirmPassword) {
						this.userValidation.confirmPassword = false;
						errorMessages += this.$t('alerts.passwordConfirmationFail') + '<br />';
					} else {
						this.userValidation.confirmPassword = true;
					}
				}
			}

			if (this.user.user_role_id == null) {
				success = false;
				this.userValidation.user_role_id = false;
			} else {
				this.userValidation.user_role_id = true;
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.user.id != 0) {
					action = 'put';
					addition = '/' + vm.user.id;
				}
				this.$APICall(action, 'users' + addition, this.user, (data, success) => {
					if (success) {
						vm.inEditMode = false;
						if (vm.user.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						if (after !== null) {
							after();
						} else {
							vm.backClick();
						}
					} else if (data === '409') {
						vm.$alert(vm.$t('alerts.userExistsWithGivenEmail'));
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		},
	},
	beforeRouteLeave(to, from, next) {
		let vm = this;
		if (this.inEditMode) {
			this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
				if (result) {
					if (vm.lockTimer !== null) clearInterval(vm.lockTimer);
					vm.$removeLock(vm, vm.lockKey + '|' + vm.user.id);
					next(true);
				} else {
					next(false);
				}
			});
		} else {
			if (this.lockTimer !== null) clearInterval(this.lockTimer);
			vm.$removeLock(vm, vm.lockKey + '|' + vm.user.id);
			next(true);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		if (this.$myStore.state.user.user_role_id == 2) {
			this.$router.replace('/candidates');
		}
		let vm = this;
		if (this.user.id != 0) {
			this.$APICall('get', 'users/' + this.user.id, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.user = usableData;
					vm.$myStore.commit('setBreadcrumbs', [
						{
							text: vm.$t('modules.userAccounts'),
							href: '/#/user-accounts',
							disabled: false,
						},
						{
							text: vm.user.first_name + ' ' + vm.user.last_name + ' (' + vm.user.id + ')',
							href: '/#/user-accounts/' + vm.user.id,
							disabled: true,
						},
					]);
					vm.$nextTick(() => {
						vm.initialLoad = true;
					});
				}
			});
		} else {
			this.$myStore.commit('setBreadcrumbs', [
				{
					text: this.$t('modules.userAccounts'),
					href: '/#/user-accounts',
					disabled: false,
				},
				{
					text: this.$t('modules.newUserAccount'),
					href: '/#/user-accounts/0',
					disabled: true,
				},
			]);
			this.inEditMode = true;
			this.initialLoad = true;
		}
	},
};
</script>

<style scoped></style>
